/* tslint:disable */
/* eslint-disable */
/**
 * OasisExplorer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatorCommissionScheduleRates
 */
export interface ValidatorCommissionScheduleRates {
    /**
     * 
     * @type {number}
     * @memberof ValidatorCommissionScheduleRates
     */
    start?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidatorCommissionScheduleRates
     */
    rate?: string;
}

export function ValidatorCommissionScheduleRatesFromJSON(json: any): ValidatorCommissionScheduleRates {
    return ValidatorCommissionScheduleRatesFromJSONTyped(json, false);
}

export function ValidatorCommissionScheduleRatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorCommissionScheduleRates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': !exists(json, 'start') ? undefined : json['start'],
        'rate': !exists(json, 'rate') ? undefined : json['rate'],
    };
}

export function ValidatorCommissionScheduleRatesToJSON(value?: ValidatorCommissionScheduleRates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': value.start,
        'rate': value.rate,
    };
}


